import { $ } from "@/plug/Axios";

export default {
  /**
   * 地址信息
   */
  addressInfo: {
    /*
     * 编辑
     * address 地址 (string query )
     * city 市 (string query )
     * district 区 (string query )
     * id  (integer query )
     * province 省 (string query )
     * searchStatus 查询状态 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/addressInfo", p, c)
  },
  addressInfo_getByAddress: {
    /*
     * 根据地址获取
     * address address (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/addressInfo/getByAddress", p, c)
  },
  addressInfo_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/addressInfo/list", p, c)
  },

  /**
   * advert-callback-controller
   */
  advertCallback_data: {
    /*
     * data
     * aid aid (string query )
     * androidid androidid (string query )
     * callback_url callback_url (string query )
     * cid cid (string query )
     * convert_id convert_id (string query )
     * csite csite (string query )
     * ctype ctype (string query )
     * idfa idfa (string query )
     * imei imei (string query )
     * ip ip (string query )
     * mac mac (string query )
     * oaid oaid (string query )
     * os os (string query )
     * ts ts (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/advertCallback/data", p, c)
  },

  /**
   * 经职院学习
   */
  autoCourse: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/autoCourse", p, c)
  },
  autoCourse_batchStart: {
    /*
     * 批量重新学习
     * statusList 学习状态，多选 (array query required)
     */
    post: (p, c) => $.post("/api/bms/extension/autoCourse/batchStart", p, c)
  },
  autoCourse_commitCode: {
    /*
     * 提交验证码
     * code code (string query required)
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/autoCourse/commitCode", p, c)
  },
  autoCourse_downloadMould: {
    /*
     * 下载模板
     */
    get: (p, c) => $.get("/api/bms/extension/autoCourse/downloadMould", p, c)
  },
  autoCourse_getByUserName: {
    /*
     * 根据用户名查询-客户端调用
     * userName 用户名 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/autoCourse/getByUserName", p, c)
  },
  autoCourse_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/autoCourse/list", p, c)
  },
  autoCourse_listCourseItem: {
    /*
     * 课件列表,根据下拉名称查询
     * courseName 课程名字 (string query required)
     * type type,0=全部, 1=mp4, 2=时长大于0的mp4, 3=时长大于0或非mp4 (integer query required)
     */
    get: (p, c) => $.get("/api/bms/extension/autoCourse/listCourseItem", p, c)
  },
  autoCourse_listDetail: {
    /*
     * 详情列表
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/extension/autoCourse/listDetail", p, c)
  },
  autoCourse_listItemForUpdateDuration: {
    /*
     * 取未更新课件时长的
     * limitCount 条数 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/autoCourse/listItemForUpdateDuration", p, c)
  },
  autoCourse_listSimpleCourse: {
    /*
     * 简易课程列表, 取课件下拉用
     */
    get: (p, c) => $.get("/api/bms/extension/autoCourse/listSimpleCourse", p, c)
  },
  autoCourse_reStudy: {
    /*
     * 重新学习-只把状态从完成变成未开始
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/autoCourse/reStudy", p, c)
  },
  autoCourse_refreshCode: {
    /*
     * 刷新验证码
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/autoCourse/refreshCode", p, c)
  },
  autoCourse_removeCourse: {
    /*
     * 删除课程
     * id 详情列表id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/extension/autoCourse/removeCourse", p, c)
  },
  autoCourse_saveCourseItem: {
    /*
     * 解析课件
     * cdn cdn路径 (string query required)
     * content 课程信息json (string query required)
     * courseName 课程名字 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/autoCourse/saveCourseItem", p, c)
  },
  autoCourse_saveCourseRecord: {
    /*
     * 保存课程信息，客户端调用
     * course 课程 (string query required)
     * courseInfo 课程信息json (string query required)
     * remark 备注 (string query required)
     * status 状态 (string query required)
     * userName 用户名 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/autoCourse/saveCourseRecord", p, c)
  },
  autoCourse_saveCourseRecordResult: {
    /*
     * 保存课程信息学习结果，客户端调用
     * course 课程 (string query required)
     * courseStudyResult 学习结果 (string query required)
     * status 状态 (string query required)
     * userName 用户名 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/autoCourse/saveCourseRecordResult", p, c)
  },
  autoCourse_start: {
    /*
     * 开始学习
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/autoCourse/start", p, c)
  },
  autoCourse_update: {
    /*
     * 编辑
     * id id (integer query required)
     * password 登录密码 (string query required)
     * userName 登录用户名 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/autoCourse/update", p, c)
  },
  autoCourse_updateDuration: {
    /*
     * 更新课件时长
     * jsonStr jsonStr (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/autoCourse/updateDuration", p, c)
  },
  autoCourse_updateSingleDuration: {
    /*
     * 更新课件时长-单个
     * duration duration (integer query required)
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/autoCourse/updateSingleDuration", p, c)
  },
  autoCourse_updateToken: {
    /*
     * 更新token等-客户端调用
     * id id (integer query required)
     * sessionId sessionId (string query required)
     * token token (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/autoCourse/updateToken", p, c)
  },
  autoCourse_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/extension/autoCourse/upload", p, c)
  },

  /**
   * 对账单
   */
  bill_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/extension/bill/export", p, c)
  },
  bill_getSummaryType: {
    /*
     * 获取摘要类型
     */
    get: (p, c) => $.get("/api/bms/extension/bill/getSummaryType", p, c)
  },
  bill_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/bill/list", p, c)
  },
  bill_refresh: {
    /*
     * 刷新
     * date 日期：yyyy-MM-dd (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/bill/refresh", p, c)
  },
  bill_refreshByAccount: {
    /*
     * 刷新
     * account 账号 (string query )
     * date 日期：yyyy-MM-dd (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/bill/refreshByAccount", p, c)
  },
  bill_setSummaryType: {
    /*
     * 设置摘要类型
     * summaryTypes 摘要类型json字符串 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/bill/setSummaryType", p, c)
  },
  bill_updateType: {
    /*
     * 更新类型类型
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/extension/bill/updateType", p, c)
  },

  /**
   * 分类
   */
  classification: {
    /*
     * 添加
     * firstLevel 一级 (string query )
     * fourthLevel 四级 (string query )
     * id  (integer query )
     * secondLevel 二级 (string query )
     * thirdLevel 三级 (string query )
     * type 分类类型 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/classification", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/classification", p, c)
  },
  classification_listFirstLevel: {
    /*
     * 一级列表
     * type 分类类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/classification/listFirstLevel", p, c)
  },
  classification_listForComplaint: {
    /*
     * 投诉分类列表
     */
    get: (p, c) =>
      $.get("/api/bms/extension/classification/listForComplaint", p, c)
  },
  classification_listFourthLevel: {
    /*
     * 四级列表
     * firstLevel 一级类型 (string query required)
     * secondLevel 二级类型 (string query required)
     * thirdLevel 三级类型 (string query required)
     * type 分类类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/classification/listFourthLevel", p, c)
  },
  classification_listSecondLevel: {
    /*
     * 二级列表
     * firstLevel 一级类型 (string query required)
     * type 分类类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/classification/listSecondLevel", p, c)
  },
  classification_listThirdLevel: {
    /*
     * 三级列表
     * firstLevel 一级类型 (string query required)
     * secondLevel 一级类型 (string query required)
     * type 分类类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/classification/listThirdLevel", p, c)
  },

  /**
   * 列表标签
   */
  columnLabel: {
    /*
     * 添加
     * id  (integer query )
     * name 标签名字 (string query )
     * type 标签类型 (string query )
     * url 标签地址 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/columnLabel", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/columnLabel", p, c)
  },
  columnLabel_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/columnLabel/list", p, c)
  },
  columnLabel_listSimple: {
    /*
     * 简易列表
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/columnLabel/listSimple", p, c)
  },
  columnLabel_listType: {
    /*
     * 类型列表
     */
    get: (p, c) => $.get("/api/bms/extension/columnLabel/listType", p, c)
  },

  /**
   * 电脑设备信息
   */
  computerInfo_checkProd: {
    /*
     * 添加
     */
    get: (p, c) => $.get("/api/bms/extension/computerInfo/checkProd", p, c)
  },
  computerInfo_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/extension/computerInfo/export", p, c)
  },
  computerInfo_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/computerInfo/list", p, c)
  },
  computerInfo_save: {
    /*
     * 添加
     * adminId 使用人 (integer query )
     * adminName 使用人 (string query )
     * cpuMemorySize cpu显存 (number query required)
     * cpuName cpu (string query required)
     * cpuTaskCount cpu线程数 (integer query required)
     * hardDiskId 硬盘编号 (string query required)
     * hardDiskSize 硬盘大小 (number query required)
     * mainBoardId 主板编号 (string query required)
     * memorySize 内存大小 (number query required)
     * systemName 操作系统 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/computerInfo/save", p, c)
  },
  computerInfo_updateNo: {
    /*
     * 添加编辑电脑编号
     * displayerNo 显示器编号 (string query )
     * id id (integer query required)
     * mainNo 主机编号 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/computerInfo/updateNo", p, c)
  },

  /**
   * ding-task-controller
   */
  dingTask_finishTask: {
    /*
     * 完成代办
     * adminId adminId (integer query )
     * contentId 来源ID (integer query )
     */
    put: (p, c) => $.put("/api/bms/extension/dingTask/finishTask", p, c)
  },
  dingTask_removeTask: {
    /*
     * 删除代办
     * adminId adminId (integer query )
     * contentId 来源ID (integer query )
     */
    delete: (p, c) => $.delete("/api/bms/extension/dingTask/removeTask", p, c)
  },
  dingTask_save: {
    /*
     * 新增代办
     * appUrl appUrl (string query )
     * contentId 来源ID (integer query )
     * deadline 截止时间(2022-08-05 23:59:59) (string query )
     * description 代办描述 (string query )
     * pcUrl pcUrl (string query )
     * targetAdminId targetAdminId (integer query )
     * title 代办标题 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/dingTask/save", p, c)
  },

  /**
   * 钉钉
   */
  dingtalk_addLog: {
    /*
     * 添加日志
     * createId 日志创建人 (integer query required)
     * fieldNames 字段名称 (array query required)
     * fieldValues 字段值 (array query required)
     * groupIds 接受人群id (array query )
     * templateId 日志模板id (string query required)
     * toAdminIds 接受人id (array query )
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/addLog", p, c)
  },
  dingtalk_changeScheduleMember: {
    /*
     * 添加或者删除日程参与者
     * adminIds 参与人员 (array query required)
     * createId 日程创建人 (integer query required)
     * scheduleId 日程id (string query required)
     * type 类型添加|删除 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/dingtalk/changeScheduleMember", p, c)
  },
  dingtalk_createProcessInstance: {
    /*
     * 发起钉钉审批实例
     * adminId 管理员id (integer query required)
     * approvalUserIds 审批人钉钉id (array query )
     * componentTypes 控件类型 (array query required)
     * dingDepartmentId 钉钉部门id (integer query required)
     * names 表单项名字 (array query required)
     * processCode 审批流的唯一码 (string query required)
     * values 表单项值 (array query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/dingtalk/createProcessInstance", p, c)
  },
  dingtalk_createSchedule: {
    /*
     * 创建日程
     * address 地址 (string query required)
     * adminIds 参与人员 (array query required)
     * content 内容 (string query required)
     * createId 创建人员 (integer query required)
     * endTime 结束时间 (string query required)
     * reminderMinutes 多少分钟前提醒 (integer query required)
     * startTime 开始时间 (string query required)
     * title 标题 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/createSchedule", p, c)
  },
  dingtalk_getInstanceResp: {
    /*
     * 获取钉钉审批实例
     * instanceId 审批实例id (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/dingtalk/getInstanceResp", p, c)
  },
  dingtalk_postRequest: {
    /*
     * 钉钉post请求
     * appName App名称 (string query )
     * keys 请求参数key (array query )
     * url 请求id (string query required)
     * values 请求参数value (array query )
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/postRequest", p, c)
  },
  dingtalk_refreshDingAccessToken: {
    /*
     * 刷新钉钉的AccessToken
     * appName App名称 (string query )
     */
    post: (p, c) =>
      $.post("/api/bms/extension/dingtalk/refreshDingAccessToken", p, c)
  },
  dingtalk_removeSchedule: {
    /*
     * 删除日程
     * createId 日程创建人 (integer query required)
     * scheduleId 日程id (string query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/extension/dingtalk/removeSchedule", p, c)
  },
  dingtalk_sendDingMessage: {
    /*
     * 发送钉钉消息
     * adminId 接收人id (integer query required)
     * appName 小程序名称 (string query )
     * message 消息 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/sendDingMessage", p, c)
  },
  dingtalk_sendDingOAMessage: {
    /*
     * 发送钉钉消息
     * adminId 接收人id (integer query required)
     * appName 小程序名称 (string query )
     * content 内容 (string query required)
     * pcUrl PC端链接 (string query required)
     * title 标题 (string query required)
     * url 钉钉小程序链接 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/dingtalk/sendDingOAMessage", p, c)
  },
  dingtalk_sendGroupFile: {
    /*
     * 发送群文件
     * fileName 文件名 (string query required)
     * fileType 文件类型 (string query required)
     * mediaId 文件id (string query required)
     * openConversationId 群id (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/sendGroupFile", p, c)
  },
  dingtalk_syncContinueStudent: {
    /*
     * 同步继教院学生
     * appConfigId 钉钉配置id (integer query )
     */
    put: (p, c) =>
      $.put("/api/bms/extension/dingtalk/syncContinueStudent", p, c)
  },
  dingtalk_syncOrganization: {
    /*
     * 同步部门和账号
     */
    put: (p, c) => $.put("/api/bms/extension/dingtalk/syncOrganization", p, c)
  },
  dingtalk_uploadMedia: {
    /*
     * 上传钉钉文件
     * path 路径 (string query required)
     * type 类型：image|voice|video|file (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalk/uploadMedia", p, c)
  },

  /**
   * 钉钉配置
   */
  dingtalkConfig: {
    /*
     * 添加
     * agentId 代理id (string query )
     * appKey appKey (string query )
     * appName 小程序名字 (string query )
     * appSecret appSecret (string query )
     * id  (integer query )
     * type 类型：内部、继教院学生 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/dingtalkConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/dingtalkConfig", p, c)
  },
  dingtalkConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/dingtalkConfig/list", p, c)
  },
  dingtalkConfig_refreshAttendance: {
    /*
     * 刷新考勤数据
     * attendanceId 考勤id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/extension/dingtalkConfig/refreshAttendance", p, c)
  },
  dingtalkConfig_refreshCache: {
    /*
     * 刷新缓存
     */
    put: (p, c) => $.put("/api/bms/extension/dingtalkConfig/refreshCache", p, c)
  },
  dingtalkConfig_syncContinueStudent: {
    /*
     * 同步继教院学生（所有）
     */
    put: (p, c) =>
      $.put("/api/bms/extension/dingtalkConfig/syncContinueStudent", p, c)
  },

  /**
   * 快递查询
   */
  expressInfo_callback: {
    /*
     * 接收回调
     * param param (string query required)
     * sign sign (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/expressInfo/callback", p, c)
  },
  expressInfo_exportCompany: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/extension/expressInfo/exportCompany", p, c)
  },
  expressInfo_listCompany: {
    /*
     * 列表-基础平台-扩展管理-快递公司配置
     */
    get: (p, c) => $.get("/api/bms/extension/expressInfo/listCompany", p, c)
  },
  expressInfo_query: {
    /*
     * 查询快递信息
     * companyName 快递公司名称 (string query required)
     * expressNo 快递单号 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/expressInfo/query", p, c)
  },
  expressInfo_save: {
    /*
     * 添加编辑
     * code 编码 (string query )
     * id  (integer query )
     * name 名称 (string query )
     * type 类型 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/expressInfo/save", p, c)
  },
  expressInfo_subscribe: {
    /*
     * 订阅回调-测试
     * companyName 快递公司名称 (string query required)
     * expressNo 快递单号 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/expressInfo/subscribe", p, c)
  },
  expressInfo_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/extension/expressInfo/upload", p, c)
  },

  /**
   * 文件导入导出
   */
  fileUploadExport_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/fileUploadExport/list", p, c)
  },
  fileUploadExport_saveUpload: {
    /*
     * 添加导入
     * adminId 管理员id (integer query )
     * exportType 导出类型：实时导出、延时导出 (string query )
     * fileUrl 文件地址 (string query )
     * id  (integer query )
     * requestParams 请求参数 (string query )
     * requestPath 请求路径 (string query )
     * type 类型：导入、导出 (string query )
     */
    post: (p, c) =>
      $.post("/api/bms/extension/fileUploadExport/saveUpload", p, c)
  },

  /**
   * 人社证书团购活动
   */
  groupPayActivity_createGroupEnroll: {
    /*
     * 创建新团报
     * currentLevel 当前学历(本科及以上，本科以下） (string query required)
     * enrollTeacherId 招生老师ID (integer query required)
     * idCardNo 身份证 (string query required)
     * majorId 专业ID (integer query required)
     * name 姓名 (string query required)
     * phone 手机号 (string query required)
     * type 类型：团报、单报 (string query required)
     */
    put: (p, c) =>
      $.put("/api/bms/extension/groupPayActivity/createGroupEnroll", p, c)
  },
  groupPayActivity_getActivityTime: {
    /*
     * 查询活动时间
     */
    get: (p, c) =>
      $.get("/api/bms/extension/groupPayActivity/getActivityTime", p, c)
  },
  groupPayActivity_joinGroupEnroll: {
    /*
     * 加入团报
     * currentLevel 当前学历(本科及以上，本科以下） (string query required)
     * groupPayActivityId 学生分享码识别的ID (integer query required)
     * idCardNo 身份证 (string query required)
     * majorId 专业ID (integer query required)
     * name 姓名 (string query required)
     * phone 手机号 (string query required)
     */
    put: (p, c) =>
      $.put("/api/bms/extension/groupPayActivity/joinGroupEnroll", p, c)
  },
  groupPayActivity_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/groupPayActivity/list", p, c)
  },
  groupPayActivity_listActivityMajor: {
    /*
     * 查询活动专业
     */
    get: (p, c) =>
      $.get("/api/bms/extension/groupPayActivity/listActivityMajor", p, c)
  },
  groupPayActivity_listGroupId: {
    /*
     * 查询拼团编号列表
     */
    get: (p, c) =>
      $.get("/api/bms/extension/groupPayActivity/listGroupId", p, c)
  },
  groupPayActivity_scanCode: {
    /*
     * 扫码
     * enrollTeacherId enrollTeacherId (integer query required)
     */
    put: (p, c) => $.put("/api/bms/extension/groupPayActivity/scanCode", p, c)
  },
  groupPayActivity_searchByGroupId: {
    /*
     * 根据GroupId查询参团
     * groupId GroupId (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/groupPayActivity/searchByGroupId", p, c)
  },
  groupPayActivity_searchByPhone: {
    /*
     * 根据手机号查询参团列表
     * phone 手机号 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/groupPayActivity/searchByPhone", p, c)
  },

  /**
   * 汇付付款人信息
   */
  huifuPayer_getPayerId: {
    /*
     * 获取付款人id
     * name 姓名 (string query required)
     * payAccount 收款账号 (string query required)
     * phone 手机号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/huifuPayer/getPayerId", p, c)
  },

  /**
   * id关联表
   */
  idAssociation_listContentId: {
    /*
     * 通过类型和关联字段获取内容id
     * associationId 关联id (integer query required)
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/idAssociation/listContentId", p, c)
  },
  idAssociation_setContentId: {
    /*
     * 设置内容id
     * associationId 关联id (integer query required)
     * contentIds 内容id (array query required)
     * type 类型 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/idAssociation/setContentId", p, c)
  },

  /**
   * 安心付周期卡核销订单
   */
  merchantCardDeductionOrder_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardDeductionOrder/export", p, c)
  },
  merchantCardDeductionOrder_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardDeductionOrder/list", p, c)
  },
  merchantCardDeductionOrder_listByCardId: {
    /*
     * 根据售卖订单id获取核销订单列表
     * cardId 售卖订单id (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardDeductionOrder/listByCardId", p, c)
  },
  merchantCardDeductionOrder_sync: {
    /*
     * 根据售卖订单id同步
     * cardOrderId 售卖订单id (integer query )
     */
    put: (p, c) =>
      $.put("/api/bms/extension/merchantCardDeductionOrder/sync", p, c)
  },

  /**
   * 安心付周期卡售卖订单
   */
  merchantCardOrder_bind: {
    /*
     * 绑定
     * feeType 收费单类型 (string query )
     * orderId 业务单ID (string query required)
     * schoolRollId 合同id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/extension/merchantCardOrder/bind", p, c)
  },
  merchantCardOrder_close: {
    /*
     * 关闭安心付周期卡订单
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/extension/merchantCardOrder/close", p, c)
  },
  merchantCardOrder_create: {
    /*
     * 创建
     * cardTemplateId 安心付卡模板ID (string query required)
     * feeType 收费单类型 (string query )
     * msgAppId 小程序id (string query required)
     * schoolRollId 合同编号 (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/merchantCardOrder/create", p, c)
  },
  merchantCardOrder_detailsByOutOrderNo: {
    /*
     * 根据outOrderNo查询订单详情
     * outOrderNo outOrderNo (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardOrder/detailsByOutOrderNo", p, c)
  },
  merchantCardOrder_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/extension/merchantCardOrder/export", p, c)
  },
  merchantCardOrder_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/merchantCardOrder/list", p, c)
  },
  merchantCardOrder_listSimple: {
    /*
     * 简易列表
     * feeType 收费单类型 (string query )
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/merchantCardOrder/listSimple", p, c)
  },
  merchantCardOrder_sync: {
    /*
     * 同步订单
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     */
    put: (p, c) => $.put("/api/bms/extension/merchantCardOrder/sync", p, c)
  },

  /**
   * 安心付周期卡
   */
  merchantCardTemplate: {
    /*
     * 添加
     * cardPropertyId 客一价协议ID (string query )
     * cardTemplateId 卡id (string query )
     * cardTemplateName 卡模板名称 (string query )
     * cardTemplateStatus 卡状态 (string query )
     * cycleValue 周期计费参数 (string query )
     * hotline 客服电话 (string query )
     * id  (integer query )
     * msgAppId 小程序id (string query )
     * outCardId 外部卡id (string query )
     * price 价格 (number query )
     * rejectReason 驳回原因 (string query )
     * salableEndTime 售卖结束时间 (string query )
     * salableStartTime 售卖开始时间 (string query )
     * usableCount 期数 (integer query )
     * usableShopId 可用门店id (string query )
     * useInstruction 使用说明 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/merchantCardTemplate", p, c)
  },
  merchantCardTemplate_getCardInfoBySchoolRollId: {
    /*
     * 根据合同id获取周期卡信息
     * feeType 收费单类型 (string query )
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/extension/merchantCardTemplate/getCardInfoBySchoolRollId",
        p,
        c
      )
  },
  merchantCardTemplate_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/merchantCardTemplate/list", p, c)
  },
  merchantCardTemplate_modifyStatus: {
    /*
     * 上下架
     * id 周期卡id (integer query )
     * operateStatus 状态：发布、下架 (string query )
     */
    put: (p, c) =>
      $.put("/api/bms/extension/merchantCardTemplate/modifyStatus", p, c)
  },
  merchantCardTemplate_sync: {
    /*
     * 根据小程序id同步
     * msgAppId 小程序id (string query required)
     */
    put: (p, c) => $.put("/api/bms/extension/merchantCardTemplate/sync", p, c)
  },

  /**
   * 门店
   */
  merchantShop: {
    /*
     * 添加
     * id  (integer query )
     * msgAppId 小程序id (string query )
     * shopId 门店id (string query )
     * shopName 门店名字 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/merchantShop", p, c)
  },
  merchantShop_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/merchantShop/list", p, c)
  },
  merchantShop_listSimple: {
    /*
     * 简易列表
     */
    get: (p, c) => $.get("/api/bms/extension/merchantShop/listSimple", p, c)
  },

  /**
   * 扩展（其他）
   */
  other_broadcastContinueEnroll: {
    /*
     * 继教院|服务部业绩汇报-上传图片服务器临时发送到群
     * localFilePath localFilePath (string query )
     * remoteUrl 七牛url (string query )
     * type 类型：继教院|服务部|成教学习规划部|中军驻点线索 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/broadcastContinueEnroll", p, c)
  },
  other_broadcastDegreeEnroll: {
    /*
     * 播报学历招生情况
     * type 类型：学历、继教院、自考、线索（免试专升本） (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/broadcastDegreeEnroll", p, c)
  },
  other_cancelTravel: {
    /*
     * 查询转账状态
     * endDate 结束日期 (string query required)
     * endTime 结束时间：显示上午，下午，传 AM，PM (string query required)
     * phone 手机号 (string query required)
     * startDate 开始日期 (string query required)
     * startTime 开始时间：显示上午，下午，传 AM，PM (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/cancelTravel", p, c)
  },
  other_downloadEnrollLetter: {
    /*
     * 下载录取贺函
     * level 层次 (string query required)
     * major 专业 (string query required)
     * name 姓名 (string query required)
     * site 学校 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/downloadEnrollLetter", p, c)
  },
  other_downloadServerFile: {
    /*
     * 下载服务器文件
     * filePath 文件路径 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/downloadServerFile", p, c)
  },
  other_getAlipayBillUrl: {
    /*
     * 支付宝对账单
     * billDate 账单日期 (string query required)
     * payAccount 收款账号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getAlipayBillUrl", p, c)
  },
  other_getCache: {
    /*
     * 根据类型获取缓存
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getCache", p, c)
  },
  other_getCacheByAdmin: {
    /*
     * 根据token和类型获取缓存
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getCacheByAdmin", p, c)
  },
  other_getCacheByToken: {
    /*
     * 根据token和类型获取缓存
     * type 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getCacheByToken", p, c)
  },
  other_getFileMd5String: {
    /*
     * 查询文件MD5
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/getFileMd5String", p, c)
  },
  other_getFileMd5String1: {
    /*
     * 查询文件MD5
     * file file (file formData required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/getFileMd5String1", p, c)
  },
  other_getRedis: {
    /*
     * 获取redis缓存
     * key key (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getRedis", p, c)
  },
  other_getResourceByMd5: {
    /*
     * 根据MD5查询资源
     * md5String md5 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/getResourceByMd5", p, c)
  },
  other_getResourceUrlById: {
    /*
     * 根据id查询资源Url
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/getResourceUrlById", p, c)
  },
  other_getUpToken: {
    /*
     * 获取上传凭证
     * ext 文件扩展名 (string query required)
     * name 文件名 (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/other/getUpToken", p, c)
  },
  other_getWechatBill: {
    /*
     * 微信对账单
     * billDate 账单日期 (string query required)
     * payAccount 收款账号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/getWechatBill", p, c)
  },
  other_htmlToImage: {
    /*
     * html转图片
     * url 地址 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/htmlToImage", p, c)
  },
  other_incrementRedis: {
    /*
     * 根据key获取值并自增
     * adminId 管理员id (string query required)
     * title 类型 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/incrementRedis", p, c)
  },
  other_initRedis: {
    /*
     * 根据key初始化值
     * adminId 管理员id (string query required)
     * title 类型 (string query required)
     */
    put: (p, c) => $.put("/api/bms/extension/other/initRedis", p, c)
  },
  other_listCardOrder: {
    /*
     * 获取安心付订单信息
     * end 结束时间 (string query )
     * payAccount 收款账号 (string query required)
     * shopId 门店 (string query required)
     * start 开始时间 (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/other/listCardOrder", p, c)
  },
  other_parseIdCard: {
    /*
     * 解析身份证
     * cardSide 正面(front)｜反面(back) (string query required)
     * url 图片地址 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/parseIdCard", p, c)
  },
  other_parseImg: {
    /*
     * 解析图片
     * url 图片地址 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/parseImg", p, c)
  },
  other_parsePdf: {
    /*
     * 解析pdf
     * pdfFile pdfFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/parsePdf", p, c)
  },
  other_parseVerifyCode: {
    /*
     * 解析验证码
     * extrendName 文件扩展名 (string query required)
     * url 验证码地址 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/parseVerifyCode", p, c)
  },
  other_parseWord: {
    /*
     * 解析word（纯文本）
     * wordFile wordFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/parseWord", p, c)
  },
  other_parseWordTable: {
    /*
     * 解析word表格（多个表格以列表形式返回）
     * cellSplit 单元格分隔符 (string query required)
     * rowSplit 行分隔符 (string query required)
     * wordFile wordFile (file formData required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/parseWordTable", p, c)
  },
  other_pay: {
    /*
     * 付款
     * amount 金额 (number query required)
     * payAccount 收款账号 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/pay", p, c)
  },
  other_putCache: {
    /*
     * 根据类型存入缓存
     * content 内容 (string query required)
     * type 类型 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/putCache", p, c)
  },
  other_putCacheByAdmin: {
    /*
     * 根据登录信息和类型存入缓存
     * content 内容 (string query required)
     * type 类型 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/putCacheByAdmin", p, c)
  },
  other_putCacheByToken: {
    /*
     * 根据token和类型存入缓存
     * content 内容 (string query required)
     * type 类型 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/putCacheByToken", p, c)
  },
  other_removeCache: {
    /*
     * 根据类型删除缓存
     * type 类型 (string query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/other/removeCache", p, c)
  },
  other_removeCacheByAdmin: {
    /*
     * 根据登录信息和类型删除缓存
     * type 类型 (string query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/extension/other/removeCacheByAdmin", p, c)
  },
  other_removeCacheByToken: {
    /*
     * 根据token和类型删除缓存
     * type 类型 (string query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/extension/other/removeCacheByToken", p, c)
  },
  other_saveResource: {
    /*
     * 添加资源
     * cloudUrl 七牛地址 (string query required)
     * fileName 文件名 (string query required)
     * md5String md5 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/saveResource", p, c)
  },
  other_searchOrderInfo: {
    /*
     * 查询订单信息
     * orderNo 订单号 (string query )
     * payAccount 收款账号 (string query )
     * payAccountIdentity 收款账号 (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/other/searchOrderInfo", p, c)
  },
  other_searchTransferResp: {
    /*
     * 查询转账状态
     * outBizNo 订单号 (string query required)
     * payAccount 打款账号：公司支付宝 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/searchTransferResp", p, c)
  },
  other_sendDingTalkMassMessage: {
    /*
     * 发送钉钉消息-所有启用的管理员
     * message 消息 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/sendDingTalkMassMessage", p, c)
  },
  other_sendDingTalkMessage: {
    /*
     * 发送钉钉消息
     * adminId 管理员id (integer query required)
     * message 消息 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/sendDingTalkMessage", p, c)
  },
  other_testBroadcastPerson: {
    /*
     * 测试个人业绩播报
     * adminId 管理员id (integer query required)
     * amountInfo 缴费金额信息 (string query )
     * area 区县 (string query )
     * clueActivateName 线索提供人 (string query )
     * departmentId 合同部门 (integer query required)
     * fullPayment 是否全款, 1是0否 (integer query )
     * major 专业 (string query )
     * site 学校 (string query )
     * siteType 学校类型 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/other/testBroadcastPerson", p, c)
  },
  other_testClueBroadcastPerson: {
    /*
     * 测试线索创建播报
     * adminId 管理员id (integer query required)
     * area 线索-区 (string query )
     * city 线索-市 (string query )
     * sorting 当前第XX条 (integer query )
     * totalCount 总计 (integer query )
     * type 类型：只支持免试专升本 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/testClueBroadcastPerson", p, c)
  },
  other_testHccbPay: {
    /*
     * 测试杭州银行支付
     * amount 付款金额 (number query required)
     * body 付款说明 (string query required)
     * payAccount 付款账号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/other/testHccbPay", p, c)
  },
  other_testPreAdminId: {
    /*
     * 取PreAdminId
     */
    get: (p, c) => $.get("/api/bms/extension/other/testPreAdminId", p, c)
  },
  other_testPreDepartmentIds: {
    /*
     * 取PreDepartmentIds
     */
    get: (p, c) => $.get("/api/bms/extension/other/testPreDepartmentIds", p, c)
  },
  other_timestamp: {
    /*
     * 服务器时间戳
     */
    get: (p, c) => $.get("/api/bms/extension/other/timestamp", p, c)
  },
  other_uploadFileToServer: {
    /*
     * 上传文件到服务器
     * file file (file formData required)
     * subDirectory 保存文件子路径名字 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/other/uploadFileToServer", p, c)
  },
  other_uploadImageBase64ToServer: {
    /*
     * 上传图片base64到服务器
     * base64 base64 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/uploadImageBase64ToServer", p, c)
  },
  other_uploadImageBase64ToServerLocal: {
    /*
     * 上传图片base64到服务器，不传7牛
     * base64 base64 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/uploadImageBase64ToServerLocal", p, c)
  },
  other_uploadImageByteToServer: {
    /*
     * 上传图片byte到七牛
     * data 图片byte[] (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/other/uploadImageByteToServer", p, c)
  },

  /**
   * 抖音智能外呼
   */
  outboundCall: {
    /*
     * 添加编辑
     * concurrency 并发量 (integer query )
     * endTime 结束时间 (string query )
     * forbidTimeList 禁呼时间段 (string query )
     * id  (integer query )
     * name 名称 (string query )
     * numberPoolNo 号码池编号 (string query )
     * numbers 外呼号码 (string query )
     * remark 备注 (string query )
     * resultDetail 查询返回详情 (string query )
     * ringAgainInterval 重呼间隔（分钟） (integer query )
     * ringAgainTimes 重呼次数 (integer query )
     * script 剧本名称 (string query )
     * startTime 开始时间 (string query )
     * status 状态 (string query )
     * syncTime 最近同步时间 (string query )
     * taskId taskId (string query )
     * throughRate 进度 (number query )
     */
    post: (p, c) => $.post("/api/bms/extension/outboundCall", p, c),

    /*
     * 删除, 状态未开始的才可以删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/outboundCall", p, c)
  },
  outboundCall_addCallbackUrl: {
    /*
     * 更新回调地址
     * url 回调地址 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/outboundCall/addCallbackUrl", p, c)
  },
  outboundCall_assignClue: {
    /*
     * 分配线索
     * ids 记录列表返回的id (array query required)
     * receiverId 线索接收人 (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/outboundCall/assignClue", p, c)
  },
  outboundCall_callback_callRecord: {
    /*
     * 同步外呼结果
     */
    post: (p, c) =>
      $.post("/api/bms/extension/outboundCall/callback/callRecord", p, c)
  },
  outboundCall_checkTaskResult: {
    /*
     * 查询外呼结果， 纯查询
     * limit 详情条数 (integer query required)
     * status 任务明细状态，1： 已完成 2：进行中 3：待进行 (integer query required)
     * taskId 任务ID (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/outboundCall/checkTaskResult", p, c)
  },
  outboundCall_downloadMould: {
    /*
     * 下载模板(批量导入号码)
     */
    get: (p, c) => $.get("/api/bms/extension/outboundCall/downloadMould", p, c)
  },
  outboundCall_exportRecord: {
    /*
     * 导出-智能外呼记录
     */
    get: (p, c) => $.get("/api/bms/extension/outboundCall/exportRecord", p, c)
  },
  outboundCall_getCallRecord: {
    /*
     * 查询通话录音
     * callId 记录列表返回的callId (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/outboundCall/getCallRecord", p, c)
  },
  outboundCall_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/outboundCall/list", p, c)
  },
  outboundCall_listNumberPool: {
    /*
     * 简易号码池列表
     */
    get: (p, c) => $.get("/api/bms/extension/outboundCall/listNumberPool", p, c)
  },
  outboundCall_listRecord: {
    /*
     * 列表-智能外呼记录
     */
    get: (p, c) => $.get("/api/bms/extension/outboundCall/listRecord", p, c)
  },
  outboundCall_listScripts: {
    /*
     * 简易剧本列表
     */
    get: (p, c) => $.get("/api/bms/extension/outboundCall/listScripts", p, c)
  },
  outboundCall_listSimple: {
    /*
     * 简易外呼任务列表
     */
    get: (p, c) => $.get("/api/bms/extension/outboundCall/listSimple", p, c)
  },
  outboundCall_pauseTask: {
    /*
     * 暂停外呼-状态为进行中才可以
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/outboundCall/pauseTask", p, c)
  },
  outboundCall_resumeTask: {
    /*
     * 恢复外呼-状态为用户暂停才可以
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/outboundCall/resumeTask", p, c)
  },
  outboundCall_startTask: {
    /*
     * 开始外呼,状态为未开始,且导入号码数量不为空
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/outboundCall/startTask", p, c)
  },
  outboundCall_stopTask: {
    /*
     * 终止外呼-状态为进行中或用户暂停才可以
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/outboundCall/stopTask", p, c)
  },
  outboundCall_syncNumberPool: {
    /*
     * 同步号码池
     */
    post: (p, c) =>
      $.post("/api/bms/extension/outboundCall/syncNumberPool", p, c)
  },
  outboundCall_syncScripts: {
    /*
     * 同步剧本
     */
    post: (p, c) => $.post("/api/bms/extension/outboundCall/syncScripts", p, c)
  },
  outboundCall_syncSingleResult: {
    /*
     * 同步单个外呼结果
     * id 记录列表返回的id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/outboundCall/syncSingleResult", p, c)
  },
  outboundCall_syncTaskResult: {
    /*
     * 同步外呼结果
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/outboundCall/syncTaskResult", p, c)
  },
  outboundCall_upload: {
    /*
     * 批量导入号码
     * excelFile excelFile (file formData required)
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/outboundCall/upload", p, c)
  },
  outboundCall_uploadFromSea: {
    /*
     * 从公海添加号码
     * assignEndTime 最近分配结束时间 (string query )
     * assignStartTime 最近分配开始时间 (string query )
     * calledTimes 已外呼次数(小于几次) (integer query required)
     * channel 来源渠道 (string query )
     * clueStatus 线索状态 (string query )
     * contactEndTime 最近联系结束时间 (string query )
     * contactStartTime 最近联系开始时间 (string query )
     * createEndTime 线索创建结束时间 (string query )
     * createStartTime 线索创建开始时间 (string query )
     * currentStatus 最新联系状态 (string query )
     * detail 来源详情 (string query )
     * drawCount 领取数量 (integer query required)
     * id id (integer query required)
     * province 省份 (string query )
     * sortField 排序字段 (string query )
     * sortRule 排序规则,升序降序 (string query )
     * type 线索类型 (string query )
     */
    put: (p, c) => $.put("/api/bms/extension/outboundCall/uploadFromSea", p, c)
  },

  /**
   * 支付配置
   */
  payConfig: {
    /*
     * 添加
     * apiKey 接口秘钥 (string query )
     * companyBody 公司主体 (string query )
     * extraContent 额外信息（JSON字符串） (string query )
     * id  (integer query )
     * mchId 商户ID (string query )
     * mchPublicKey 商户公钥（支付宝使用） (string query )
     * mchSecret 商户密钥 (string query )
     * mchSn 证书序列号 (string query )
     * notifyUrl 通知地址 (string query )
     * payAccount 收款账号 (string query )
     * payAccountIdentity 收款账号标识 (string query )
     * payType 类型：支付宝，微信 (string query )
     * payWay 支付方式 (string query )
     * platform 平台（微信用） (string query )
     * testNotifyUrl 测试环境通知地址 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/payConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/payConfig", p, c)
  },
  payConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/payConfig/list", p, c)
  },
  payConfig_listAccountByType: {
    /*
     * 根据类型获取账号列表
     * type 类型：支付宝、微信、汇付 (string query )
     */
    get: (p, c) => $.get("/api/bms/extension/payConfig/listAccountByType", p, c)
  },
  payConfig_listSimple: {
    /*
     * 简易列表，id为商户id
     * type 类型：支付宝、微信、支付宝小程序、汇付 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/payConfig/listSimple", p, c)
  },

  /**
   * 微信
   */
  wechat_checkOpenId: {
    /*
     * 检查openId
     * platform 平台 (string query required)
     * type 类型：小程序，公众号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/checkOpenId", p, c)
  },
  wechat_customer_assign: {
    /*
     * 在职分配-测试
     * externalUserId 学生企微ID (string query required)
     * handoverUserId 原负责人企微ID (string query required)
     * msg 转移成功后发给客户的消息，最多200个字符，不填使用默认文案 (string query )
     * newHeaderTeacherId 接收班主任ID (integer query required)
     * originHeaderTeacherId 原班主任ID (integer query required)
     * schoolRollId 合同编号 (integer query required)
     * takeoverUserId 接收人企微ID (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wechat/customer/assign", p, c)
  },
  wechat_customer_listAssignRecord: {
    /*
     * 企微分配记录
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechat/customer/listAssignRecord", p, c)
  },
  wechat_customer_listEmployee: {
    /*
     * 企微员工
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechat/customer/listEmployee", p, c)
  },
  wechat_customer_listSimpleAdmin: {
    /*
     * 简易企微员工列表
     * appName App名称，企微业务助手或中军 (string query required)
     * followUserFlag 是否开通了联系客户功能 (string query )
     * saveRecordFlag 员工是否开启会话存档 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechat/customer/listSimpleAdmin", p, c)
  },
  wechat_customer_listStudent: {
    /*
     * 企微学生
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/customer/listStudent", p, c)
  },
  wechat_customer_reAssign: {
    /*
     * 重新分配, 状态为未知或发起失败可
     * id ID (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wechat/customer/reAssign", p, c)
  },
  wechat_customer_syncStatus: {
    /*
     * 查询分配结果
     * handoverUserId 原负责人企微ID (string query required)
     * takeoverUserId 接收人企微ID  (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/extension/wechat/customer/syncStatus", p, c)
  },
  wechat_decryptMiniProgram: {
    /*
     * 小程序数据解密,解密后数据自动处理
     * encryptedData 加密数据 (string query required)
     * iv iv (string query required)
     * platform 平台 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/decryptMiniProgram", p, c)
  },
  wechat_fastReply_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/fastReply/list", p, c)
  },
  wechat_fastReply_listSimple: {
    /*
     * 简易列表
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/fastReply/listSimple", p, c)
  },
  wechat_fastReply_save: {
    /*
     * 添加
     * content  (string query )
     * id  (integer query )
     */
    post: (p, c) => $.post("/api/bms/extension/wechat/fastReply/save", p, c)
  },
  wechat_getAccessToken: {
    /*
     * 获取AccessToken
     * platform 平台 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/getAccessToken", p, c)
  },
  wechat_getRequest: {
    /*
     * 微信get请求
     * platform 平台 (string query required)
     * url url (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/getRequest", p, c)
  },
  wechat_getSignature: {
    /*
     * 获取签名
     * platform 平台 (string query required)
     * url url (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/getSignature", p, c)
  },
  wechat_postRequest: {
    /*
     * 微信post请求
     * body 请求体 (string query required)
     * platform 平台 (string query required)
     * url url (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechat/postRequest", p, c)
  },

  /**
   * 微信配置
   */
  wechatConfig: {
    /*
     * 添加
     * accountAppId 公众号应用ID (string query )
     * accountSecret 公众号密钥 (string query )
     * appAppId APP应用ID (string query )
     * appSecret APP密钥 (string query )
     * id  (integer query )
     * mpAppId 小程序应用ID (string query )
     * mpSecret 小程序密钥 (string query )
     * platform 平台名称 (string query )
     * platformIdentity 平台标识 (string query )
     * welcome 欢迎词 (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/wechatConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/extension/wechatConfig", p, c)
  },
  wechatConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/wechatConfig/list", p, c)
  },
  wechatConfig_listPlatform: {
    /*
     * 平台列表
     */
    get: (p, c) => $.get("/api/bms/extension/wechatConfig/listPlatform", p, c)
  },
  wechatConfig_refresh: {
    /*
     * 刷新缓存
     */
    put: (p, c) => $.put("/api/bms/extension/wechatConfig/refresh", p, c)
  },

  /**
   * 微信消息
   */
  wechatMessage_resend: {
    /*
     * 重新发送
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wechatMessage/resend", p, c)
  },
  wechatMessage_send: {
    /*
     * 发送微信模板消息
     * first 第一个关键字 (string query required)
     * keywords 中间关键字填充，多个用英文逗号隔开 (array query required)
     * miniProgramUrl 小程序跳转地址 (string query )
     * platform 平台 (string query required)
     * remark 最后一个关键字 (string query required)
     * title 标题 (string query required)
     * url 跳转地址 (string query )
     * userId 用户id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wechatMessage/send", p, c)
  },

  /**
   * 微信模板
   */
  wechatTemplate_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/extension/wechatTemplate/list", p, c)
  },
  wechatTemplate_listTitle: {
    /*
     * 标题列表
     * platform 平台 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wechatTemplate/listTitle", p, c)
  },
  wechatTemplate_listTitleContent: {
    /*
     * 根据平台查询简单模板列表
     * platform 平台 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/extension/wechatTemplate/listTitleContent", p, c)
  },
  wechatTemplate_refresh: {
    /*
     * 刷新
     * platform 平台 (string query required)
     */
    put: (p, c) => $.put("/api/bms/extension/wechatTemplate/refresh", p, c)
  },

  /**
   * 企业微信
   */
  wecom_addTag: {
    /*
     * 企微添加标签
     * groupId 标签组ID (string query )
     * groupName 标签组名称 (string query )
     * order 顺序 (integer query required)
     * tagName 标签名称 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/addTag", p, c)
  },
  wecom_autoRemoveTage: {
    /*
     * 定时任务-删除学生通知标签
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/autoRemoveTage", p, c)
  },
  wecom_callback: {
    /*
     * callback
     * echostr echostr (undefined body )
     * msg_signature msg_signature (string query )
     * nonce nonce (string query )
     * timestamp timestamp (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/callback", p, c)
  },
  wecom_getInfoByCode: {
    /*
     * 使用code获取登录信息，返回40029说明code过期
     * appName App名称，企微业务助手 (string query required)
     * code 登录时获取的 code (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wecom/getInfoByCode", p, c)
  },
  wecom_getInfoByUserId: {
    /*
     * 根据qwUserId查询
     * appName App名称，企微业务助手 (string query required)
     * qwUserId qwUserId (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wecom/getInfoByUserId", p, c)
  },
  wecom_getStudentList: {
    /*
     * 取外部客户列表，仅查询ID
     * appName App名称，企微业务助手or中军 (string query required)
     * qwUserId 班主任企微userId (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/getStudentList", p, c)
  },
  wecom_getTags: {
    /*
     * 取标企微签库
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/getTags", p, c)
  },
  wecom_getUnassignedList: {
    /*
     * 测试-获取所有离职员工客户列表
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/getUnassignedList", p, c)
  },
  wecom_getUserIdByPhone: {
    /*
     * getUserIdByPhone
     * phone phone (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wecom/getUserIdByPhone", p, c)
  },
  wecom_getWeComConfig: {
    /*
     * 获取签名
     * agentFlag 获取应用的JsApiTicket传1，企业的传0 (integer query required)
     * appName App名称，企微业务助手 (string query required)
     * url 网页的URL， 不包含#及其后面部分 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wecom/getWeComConfig", p, c)
  },
  wecom_pullRecord: {
    /*
     * 拉取聊天记录
     * limit 每次取多少条 (integer query )
     * pageSize 取多少次 (integer query )
     * syncAdmin 先同步会话存档的班主任，0为否，其他默认是 (integer query )
     * syncContact 拉取完是否同步服务联系记录，0为否，其他默认是 (integer query )
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/pullRecord", p, c)
  },
  wecom_refreshAccessToken: {
    /*
     * 刷新企微的AccessToken
     * appName App名称，企微业务助手 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/refreshAccessToken", p, c)
  },
  wecom_removeTag: {
    /*
     * 企微删除标签
     * tagId 标签ID (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/removeTag", p, c)
  },
  wecom_syncContactRecord: {
    /*
     * 同步企微联系记录
     * endTime endTime (string query )
     * qwUserId qwUserId (string query )
     * startTime startTime (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/syncContactRecord", p, c)
  },
  wecom_syncFollowUserList: {
    /*
     * 获取配置了客户联系功能的成员列表
     * appName App名称，企微业务助手 (string query required)
     */
    get: (p, c) => $.get("/api/bms/extension/wecom/syncFollowUserList", p, c)
  },
  wecom_syncPermitUserList: {
    /*
     * 查询已开通会话存档的班主任企微userId列表
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/syncPermitUserList", p, c)
  },
  wecom_syncUserAndCustomer: {
    /*
     * 同步企微员工，并且拉取学生列表，学生详情等
     * appName App名称，企微业务助手or中军 (string query required)
     * getStudent 是否同时拉取外部学生列表 (boolean query required)
     * getStudentDetail 是否同时拉取外部学生详情 (boolean query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/syncUserAndCustomer", p, c)
  },
  wecom_syncUserList: {
    /*
     * 同步通讯录成员
     * appName App名称，中军企微通讯录同步或企微通讯录同步 (string query required)
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/syncUserList", p, c)
  },
  wecom_testReplyFinish: {
    /*
     * 测试企微话术触达
     * endTime endTime (string query )
     * qwUserId qwUserId (string query )
     * startTime startTime (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/testReplyFinish", p, c)
  },
  wecom_testRsaDecrypt: {
    /*
     * 测试RSA解密
     * encryptMsg data (string query )
     * priKey priKey (string query )
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/testRsaDecrypt", p, c)
  },
  wecom_updateStudentTag: {
    /*
     * 企微编辑学生标签
     * addTags 添加的标签id列表 (array query )
     * appName App名称，企微业务助手 (string query required)
     * externalUserId 学生externalUserId (string query required)
     * qwUserId 班主任企微userId (string query required)
     * removeTags 删除的标签id列表 (array query )
     */
    post: (p, c) => $.post("/api/bms/extension/wecom/updateStudentTag", p, c)
  }
};
